import { useState, useRef, useEffect } from 'react'; //PC_GD_1 hooks import
import Select from 'react-select'; //PC_GD_2
import { uploadBackend } from '../../utils/Upload'; //PC_GD_3
//PC_GD_4 import functions
import {
    getPolicyAudit,
    getPolicyDropDown,
    repopulatePolicy,
    insertPolicy,
    getAckUsers,
    getUnAckUsers,
    approvalPolicy,
    updatePolicy,
} from '../../service/todo';
import { getDomainData } from '../../service/api'; //PC_GD_5
import { directory } from '../../service/PerformanceAPI'; //PC_GD_7
import { useLocation, useNavigate } from 'react-router-dom'; //PC_GD_8
import { encryptStorage } from '../../constant'; //PC_GD_9
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { getS3 } from '../../utils/Download';
import Loader from '../../StaticComponent/Loader';
import { getTimestampToDate } from '../../utils/dateConvetor';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import moment, { months } from 'moment';
import { Tooltip } from 'antd';
import DOMPurify from 'dompurify';

// PC_GD_10 define the function
export default function FormPolicy() {
    const navigateTo = useNavigate(); //PC_GD_11 useNavigate hook definition
    const getId = useLocation(); //PC_GD_12 geeting id using useLocation
    let search = window.location.search;
    let policyId = '';
    let editId = getId.state;
    let viewId = new URLSearchParams(search).get('viewId');
    let pathName = '';
    let state = 'success';
    const [editPolicyName, setEditPolicyName] = useState('');

    if (editId) {
        policyId = editId;
    } else if (viewId) {
        policyId = viewId;
    }
    // let isCreate=false;
    // if (getId && getId.state) {
    //     if (getId.state.state1 === 'create policy') {
    //         isCreate = true; // It's for creating
    //     } else {
    //         editId = getId.state; // It's for editing, assuming editId represents an identifier for editing
    //     }
    // }

    let policyDoc = '';

    //PC_GD_13 defining state variable initialised with obj

    const policyDetailsObj = {
        policyId: editId ? editId : '',
        policyName: '',
        startDate: '',
        expiryDate: '',
        controlOwner: [],
        signatureRequired: false,
        category: '',
        groupNames: [],
        individualId: [],
        policyDescription: '',
        approverDetails: [
            {
                approverLevel: 2,
                approverId: 'Sec Audits',
            },
        ],
        policyURL: policyDoc ? policyDoc : '',
        createdBy: encryptStorage.getItem('employeeId'),
    };

    const [policyDetails, setPolicyDetails] = useState(policyDetailsObj);
    if (!policyId) {
        pathName = `Create New Policy`;
    } else if (editId) {
        pathName = `Edit ${editPolicyName}`;
    } else {
        pathName = `View ${policyDetails.policyName}`;
    }
    // PC_PD_69 to  PC_PD_71 - for navigation and bread crumbs
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'How Do I?', isActive: true, path: '' },
        { title: 'Policy', isActive: true, path: '/Policy' },
        { title: pathName, isActive: false, path: '' },
    ];

    const [isLoading, setIsLoading] = useState(true);

    // const repopulateObj = {
    //     policy_name:"",
    //     start_date: "",
    //     expiry_date:"",
    //     signature_required:"",
    //     category:"",
    //     policy_description:"",
    //     policy_url:""
    // }
    // const [policyDetails,setPolicyDetails] = useState(repopulateObj)

    const [tab, setTab] = useState(false); //PC_GD_14 defining state variable
    const [searchAck, setSearchAck] = useState(''); //PC_GD_15 defining state variable
    //PC_GD_16 defining state variable for filter
    const [filterValue, setFilterValue] = useState({
        domain: '',
        fromDate: '',
        toDate: '',
    });

    //PC_GD_17 defining state variable initialised with obj
    const ackObj = {
        policyId: policyId,
        domain: '',
        fromDate: '',
        toDate: '',
        search: '',
        order: 'ASC',
        page: 1,
        limit: 10000,
        sort: 'emp_name',
    };
    const [policyAcknowledged, setPolicyAcknowledged] = useState(ackObj);

    const [ackData, setAckData] = useState([]); //PC_GD_18 defining state variable
    const [unackData, setUnackData] = useState([]); //PC_GD_19 defining state variable
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    //PC_GD_20 defining state variable initialised with obj
    const unAckObj = {
        policyId: policyId,
        domain: '',
        search: '',
        order: 'ASC',
        page: 1,
        limit: 10000,
        sort: 'e.policy_id',
    };
    const [policyUnAcknowledged, setPolicyUnAcknowledged] = useState(unAckObj);

    //PC_GD_21 defining state variable initialised with obj
    const policyValidationObj = {
        policyName: '',
        startDate: '',
        expiryDate: '',
        controlOwner: '',
        signatureRequired: '',
        // category: categoryValue.length > 1 ? 'both' : (categoryValue.length == 1 ? categoryValue[0] : ""),
        category: '',
        groupNames: '',
        individualId: '',
        policyDescription: '',
        approverDetails1: '',
        approverDetails3: '',
        policyURL: '',
        comments: '',
    };
    const [policyValidation, setPolicyValidation] = useState(policyValidationObj);

    //PC_GD_22 defining state variable initialised with obj
    const approvalObj = {
        approverAction: '',
        approverId: encryptStorage.getItem('secAudits') ? 'Sec Audits' : encryptStorage.getItem('employeeId'),
        policyId: policyId,
        comments: '',
    };
    const [policyApproval, setPolicyApproval] = useState(approvalObj);

    //PC_GD_23 defining state variable initialised
    const [controlOwnerDropdown, setControlOwnerDropdown] = useState([]);
    const [groupsDropdown, setGroupsDropdown] = useState([]); //PC_GD_24 defining state variable initialised
    const [groupCheckbox, setGroupCheckbox] = useState(false); //PC_GD_25 defining state variable initialised
    const [individualCheckbox, setIndividualCheckbox] = useState(false); //PC_GD_26 defining state variable initialised
    const [individualDropdown, setindividualDropdown] = useState([]); //PC_GD_27 defining state variable initialised

    const attachment = useRef(null); //PC_GD_28 defining state variable initialised
    const [selectedFile, setSelectedFile] = useState('');
    // const [attachmentValidation, setattachmentValidation] = useState('');
    const [auditPopup, setAuditPopup] = useState(false); //PC_GD_29 defining state variable initialised
    const [analyticsPopup, setAnalyticsPopup] = useState(false); //PC_GD_30 defining state variable initialised
    const [filterPopup, setFilterpopup] = useState(false); //PC_GD_31 defining state variable initialised

    const [bindLevel1Approver, setBindLevel1Approver] = useState([]); //PC_GD_32 defining state variable initialised
    const [bindLevel2Approver, setBindLevel2Approver] = useState([]); //PC_GD_33 defining state variable initialised
    const [bindLevel3Approver, setBindLevel3Approver] = useState([]); //PC_GD_34 defining state variable initialised

    const [level1SelectedValues, setLevel1SelectedValues] = useState([]);
    const [level3SelectedValues, setLevel3SelectedValues] = useState([]);
    const [controlOwner, setControlOwner] = useState([]);
    const [groups, setGroups] = useState([]);
    const [individual, setIndividual] = useState([]);

    const [ackCount, setAckCount] = useState([]);
    const [unackCount, setUnackCount] = useState([]);
    const [clearFilter, setClearFilter] = useState(true);

    let alert = 0;

    const [auditData, setAuditData] = useState([]); //PC_GD_35 defining state variable initialised
    const [sortOrder, setSortOrder] = useState('asc');
    const [columnOrder, setColumnOrder] = useState('ASC');
    const [columnName, setColumnName] = useState('emp_name');

    //PC_GD_36 useeffect
    useEffect(() => {
        getUnAcknowledgedUsers();
    }, [policyUnAcknowledged.search, policyUnAcknowledged.order, policyUnAcknowledged.sort, policyUnAcknowledged.limit, clearFilter]);

    useEffect(() => {
        getAcknowledgedUsers();
    }, [policyAcknowledged.search, policyAcknowledged.sort, policyAcknowledged.order, clearFilter]);

    useEffect(() => {
        getpolicyIndividual();
        getAuditHistory();
        getFormDropDowns();
        getpolicyGroups();
    }, []);

    //PC_GD_37 function definition
    async function getFormDropDowns() {
        if (policyId != '') {
            //PC_GD_38 checking for edit or view id
            //PC_GD_38 defining state variable initialised
            let response = await repopulatePolicy({ policyId: policyId });
            //PC_GD_42 check the response and setstate
            if ((response[0].statusCode = 200) && (response[1].statusCode = 200) && (response[2].statusCode = 200)) {
                setEditPolicyName(response[0]?.data[0]?.policy_name);
                setPolicyDetails({
                    policyId: policyId,
                    policyName: response[0]?.data[0]?.policy_name,
                    startDate: moment(new Date(response[0]?.data[0]?.start_date)).format('YYYY-MM-DD'),
                    expiryDate: moment(new Date(response[0]?.data[0]?.expiry_date)).format('YYYY-MM-DD'),
                    signatureRequired: response[0]?.data[0]?.signature_required,
                    category: response[0]?.data[0]?.category,
                    policyDescription: response[0]?.data[0]?.policy_description,
                    policyURL: response[0]?.data[0]?.policy_url,
                    controlOwner: response[1]?.data?.map((option) => option.policy_owner_id),
                    groupNames: response[3]?.data?.filter((group) => group.group_name !== null).map((group) => group.group_name),
                    individualId: response[3]?.data?.filter((group) => group.individual_id !== null).map((group) => group.individual_id),
                    approverDetails: response[2]?.data
                        ?.filter((group) => group.emp_id !== null)
                        .map((group) => ({ approverId: group.approver_id, approverLevel: group.approver_level })),
                    createdBy: encryptStorage.getItem('employeeId'),
                });
                if (encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1) {
                    let matchedResponse = response[2]?.data?.find(
                        (item) =>
                            item?.approver_id == (encryptStorage.getItem('secAudits') ? 'Sec Audits' : encryptStorage.getItem('employeeId'))
                    );
                    setPolicyApproval({
                        approverAction: matchedResponse?.approver_action,
                        approverId: encryptStorage.getItem('secAudits') ? 'Sec Audits' : encryptStorage.getItem('employeeId'),
                        policyId: policyId,
                        comments: matchedResponse?.comments,
                    });
                }
                setLevel1SelectedValues(
                    response[2]?.data
                        ?.filter((group) => group.emp_id !== null && group.approver_level == 1)
                        .map((group) => ({ label: group.emp_name, value: group.approver_id }))
                );
                setLevel3SelectedValues(
                    response[2]?.data
                        ?.filter((group) => group.emp_id !== null && group.approver_level == 3)
                        .map((group) => ({ label: group.emp_name, value: group.approver_id }))
                );
                setControlOwner(response[1]?.data?.map((option) => ({ label: option.emp_name, value: option.policy_owner_id })));
                setGroups(
                    response[3]?.data
                        ?.filter((group) => group.group_name !== null)
                        .map((group) => ({ label: group.group_name, value: group.group_name }))
                );
                setIndividual(
                    response[3]?.data
                        ?.filter((group) => group.individual_id !== null)
                        .map((group) => ({ label: group.emp_name, value: group.individual_id }))
                );
                setSelectedFile(response[0]?.data[0]?.policy_url);
            }
        }
        //PC_GD_43 function call
        let response = await getPolicyDropDown();
        setBindLevel3Approver(response[0].data); //PC_GD_47 setstating
        setBindLevel1Approver(response[1].data); //PC_GD_48 setstating
        setControlOwnerDropdown(response[1].data); //PC_GD_49 set stating
    }

    //PC_GD_50 function definition
    async function getpolicyGroups() {
        let response = await getDomainData(); //PC_GD_51 function call
        setGroupsDropdown(response.data.ResponseData);
    }

    //PC_GD_52 function definition
    async function getpolicyIndividual() {
        let response = await directory({}); //PC_GD_53 function call
        setindividualDropdown(response.data.ResponseData.emplist);
    }
    //PC_OC_1 function definition
    const handleChange = (e) => {
        setPolicyDetails({ ...policyDetails, [e.target.name]: e.target.value }); //PC_OC_2 set sttaaing
    };

    //PC_OC_3 function definition
    function handlecontrolowner(selectedOptions) {
        //
        //PC_OC_4 set stating
        setPolicyDetails((prevPolicyDetails) => ({
            ...prevPolicyDetails,
            controlOwner: selectedOptions.map((option) => option.value),
        }));
        setControlOwner(selectedOptions);
    }
    //PC_OC_5 function definition
    function handlegroups(selectedOptions) {
        //PC_OC_6
        setPolicyDetails({ ...policyDetails, groupNames: selectedOptions.map((option) => option.label) });
        setGroups(selectedOptions);
    }
    //PC_OC_7 function definition
    function handleindividual(selectedOptions) {
        //PC_OC_8
        setPolicyDetails({ ...policyDetails, individualId: selectedOptions.map((option) => option.value) });
        setIndividual(selectedOptions);
    }

    //PC_OC_9 function definition
    function handleApproverlevel(selectedOptions, i) {
        try {
            if (selectedOptions?.length == 0) {
                // If selectedOptions is null, remove all entries with the specified approverLevel
                policyDetails.approverDetails = policyDetails.approverDetails.filter((approver) => approver.approverLevel !== i);
                i == 1 ? setLevel1SelectedValues(selectedOptions) : setLevel3SelectedValues(selectedOptions);
            } else {
                // Construct an array of approver objects from selectedOptions
                const newApprovers = selectedOptions.map((option) => ({
                    approverLevel: i,
                    approverId: option.value,
                }));

                // Remove existing entries with the same approverLevel
                policyDetails.approverDetails = policyDetails.approverDetails.filter((approver) => approver.approverLevel !== i);

                // Add the new entries
                policyDetails.approverDetails.push(...newApprovers);
            }

            // Update state after modifying policyDetails
            i === 1 ? setLevel1SelectedValues(selectedOptions) : setLevel3SelectedValues(selectedOptions);
        } catch (e) {
            throw e;
        }
    }

    //PC_OC_12 function definition

    const handleCategory = (e) => {
        const { name, checked } = e.target;
        let newCategory = '';

        // Check if both checkboxes are checked
        if (checked && policyDetails.category === 'individual') {
            newCategory = 'both';
        } else if (checked && policyDetails.category === 'group') {
            newCategory = 'both';
        } else if (checked) {
            newCategory = name;
        } else {
            // Check if both checkboxes are unchecked
            if (policyDetails.category === 'both') {
                // Determine which checkbox was unchecked
                newCategory = name === 'group' ? 'individual' : 'group';
            }
            // If only one checkbox was previously checked, unchecking it sets newCategory to ''
        }

        setPolicyDetails({ ...policyDetails, category: newCategory });
    };


    function bindDomain() {
        return groupsDropdown?.map((value, index) => {
            return (
                <option key={index} value={value}>
                    {value}
                </option>
            );
        });
    }

    const filterCheck = () => {
        try {
            setFilterpopup(filterPopup == true ? false : true);
        } catch (error) {
            console.log(error.message, 'issue in onclick of filter');
        }
    };

    let fileData;
    const fileUpload = async (document) => {
        let dirName = `Policy-Form`;
        let file = document;

        if (file) {
            let newFileName = file.name;
            if (newFileName) {
                fileData = await uploadBackend(file, newFileName, dirName);
                setPolicyDetails((prevPolicyDetails) => ({
                    ...prevPolicyDetails,
                    policyURL: fileData,
                }));
                return fileData;
            }
        }
        return null; // Return null if file upload fails
    };

    const handleFileChange = async (e) => {
        const newFile = e.target.files[0];
        setSelectedFile(newFile);
        policyDoc = await fileUpload(newFile);
        e.target.value = null;
    };

    const removeDocument = () => {
        setSelectedFile('');
        setPolicyDetails({ ...policyDetails, ['policyURL']: '' });
    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month?.length < 2) {
            month = '0' + month;
        }
        if (day?.length < 2) {
            day = '0' + day;
        }
        return [month, day, year].join('-');
    }

    //PC_IP_1 validation
    const handleValidation = () => {
        //
        let newValidation = { ...policyValidation }; //PC_IP_2 create a copy
        //PC_IP_3 check the condition
        if (!policyDetails?.policyName.trim()) {
            newValidation.policyName = 'Policy Name is required';
            alert++;
        } else {
            newValidation.policyName = '';
        }
        //PC_IP_4
        if (!policyDetails?.startDate) {
            newValidation.startDate = 'Start Date is required';
            alert++;
        } else {
            newValidation.startDate = '';
        }
        //PC_IP_5
        if (!policyDetails?.expiryDate) {
            newValidation.expiryDate = 'Expiry Date is required';
            alert++;
        } else {
            newValidation.expiryDate = '';
        }
        //PC_IP_6
        if (!policyDetails?.category || policyDetails?.category?.length == 0) {
            newValidation.category = 'Category is Required';
            alert++;
        } else {
            newValidation.category = '';
        }
        //PC_IP_7
        if (controlOwner.length == 0) {
            newValidation.controlOwner = 'Please Select Policy Control Owner';
            alert++;
        } else {
            newValidation.controlOwner = '';
            //PC_IP_8
            if (
                policyDetails.groupNames.length == 0 &&
                (policyDetails.category.includes('both') || policyDetails.category.includes('group'))
            ) {
                newValidation.groupNames = 'Please select groups';
                alert++;
            } else {
                newValidation.groupNames = '';
            }
            //PC_IP_9
            if (
                policyDetails.individualId.length == 0 &&
                (policyDetails.category.includes('both') || policyDetails.category.includes('individual'))
            ) {
                newValidation.individualId = 'Please select individual';
                alert++;
            } else {
                newValidation.individualId = '';
            }
        }
        //PC_IP_210
        //PC_IP_11
        if (!policyDetails?.policyDescription) {
            newValidation.policyDescription = 'Policy Description is required';
            alert++;
        } else {
            newValidation.policyDescription = '';
        }
        //PC_IP_12
        if (!selectedFile) {
            newValidation.policyURL = 'Policy Document is required';
            alert++;
        } else if (selectedFile?.size > 1048576) {
            // Check file size (1MB)
            newValidation.policyURL = 'File size should be less than 1MB';
            alert++;
        } else {
            newValidation.policyURL = '';
        }
        //PC_IP_13
        if (!policyDetails?.comments && policyApproval?.approverAction == 'rejected') {
            newValidation.comments = 'Comment is required';
            alert++;
        } else {
            newValidation.comments = '';
        }
        if (level1SelectedValues?.length == 0) {
            newValidation.approverDetails1 = 'Please Select Approver level 1';
            alert++;
        } else {
            newValidation.approverDetails1 = '';
        }
        if (level3SelectedValues?.length == 0) {
            newValidation.approverDetails3 = 'Please Select Approver level 3';
            alert++;
        } else {
            newValidation.approverDetails3 = '';
        }
        setPolicyValidation(newValidation); //PC_IP_14 set state
    };

    //PC_IP_15
    const handleSubmit = async (e) => {
        e.preventDefault(); //PC_IP_16
        handleValidation(); //PC_IP_17 validation call

        //PC_IP_18 check the condition
        if (alert === 0) {
            try {
                setIsLoading(false);
                //PC_IP_20
                if (policyDoc != '') {
                    // setPolicyDetails(prevPolicyDetails => {
                    //     const updatedPolicyDetails = { ...prevPolicyDetails, policyURL: policyDoc };
                    //     // You can use updatedPolicyDetails here
                    //     return updatedPolicyDetails; // Return the updated state
                    // })
                    setPolicyDetails((prevPolicyDetails) => ({
                        ...prevPolicyDetails,
                        policyURL: policyDoc,
                    }));
                }

                // Perform form submission logic here
                //PC_IP_21
                if (!editId) {
                    let response = await insertPolicy(policyDetails);
                    if (response?.statusCode == 200 && response.data) {
                        setPolicyDetails({
                            policyId: '',
                            policyName: '',
                            startDate: '',
                            expiryDate: '',
                            controlOwner: [],
                            signatureRequired: false,
                            category: '',
                            groupNames: [],
                            individualId: [],
                            policyDescription: '',
                            approverDetails: [],
                            policyURL: '',
                        });
                        navigateTo('/policy', { state: 'success' });
                    }
                }
                //PC_IP_25 update function
                else {
                    let response = await updatePolicy(policyDetails);
                    if (response?.statusCode == 200 && response?.data) {
                        setPolicyDetails({
                            policyId: '',
                            policyName: '',
                            startDate: '',
                            expiryDate: '',
                            controlOwner: [],
                            signatureRequired: false,
                            category: '',
                            groupNames: [],
                            individualId: [],
                            policyDescription: '',
                            approverDetails: [],
                            policyURL: '',
                        });
                        navigateTo('/policy', { state: 'edit' });
                    }
                }
                setIsLoading(true);
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        }
    };

    // PC_ARP_ 1 function definition
    const handleApproval = async () => {
        try {
            setIsLoading(false);
            // PC_ARP_ 2
            //validation
            // PC_ARP_ 3
            let validation = '';
            if (!policyApproval.comments && policyApproval.approverAction == 'rejected') {
                setPolicyValidation((prevState) => ({
                    ...prevState,
                    comments: 'Comment is required',
                }));
                validation = 'Comment is required';
            } else {
                setPolicyValidation((prevState) => ({
                    ...prevState,
                    comments: '',
                }));
                validation = '';
            }
            // PC_ARP_ 4
            if (policyValidation?.comments == '') {
                let response = await approvalPolicy(policyApproval); //PC_ARP_5 call the approval function
                //PC_ARP_9
                if ((response.status = 200)) {
                    navigateTo('/policy', { state: policyApproval.approverAction });
                }
            }
            setIsLoading(true);
        } catch (error) {
            console.log(error.message);
        }
    };

    //PC_AH_1 function definition
    async function getAuditHistory() {
        let response = await getPolicyAudit({ policyId: policyId }); //PC_AH_2 function gets called
        if (response) {
            setAuditData(response.data); //PC_AH_3 set state
        }
        setIsLoading(true);
    }

    //PC_AC_1 function definition
    async function getAcknowledgedUsers() {
        let response = await getAckUsers(policyAcknowledged); //PC_AC_2 function gets called
        if (response) {
            setAckData(response[0]?.data); //PC_AC_6 set state
            setAckCount(response[1]?.data[0]?.total);
        }
        setIsLoading(true);
    }

    //PC_UAC_1 function definition
    async function getUnAcknowledgedUsers() {
        let response = await getUnAckUsers(policyUnAcknowledged); //PC_UAC_2 function gets called
        if (response) {
            setUnackData(response[0]?.data); //PC_UAC_6 set state
            setUnackCount(response[1]?.data[0]?.total);
        }
        setIsLoading(true);
    }

    function bindPolicyAudit() {
        if (auditData) {
            return auditData?.map((value, index) => {
                return (
                    <tr>
                        <td>{moment(new Date(value.created_at)).format('MM-DD-YYYY HH:mm:ss')}</td>
                        <td>{value?.emp_name}</td>
                        <td>
                            {value?.approver_action?.charAt(0)?.toUpperCase() + value?.approver_action.slice(1)}
                            {value?.policy_url ? (
                                <a
                                href="#"
                                style={{ cursor: "pointer" }} 
                                onClick={async () => {                                 
                                    window.open(await getS3(value?.policy_url), "_blank");
                               }}
                            >
                                {/* <a href={async () => { getS3(value?.policy_url) }} target="_blank"> */}
                                    {' '}
                                    View Policy
                                </a>
                            ) : (
                                <></>
                            )}
                        </td>
                        {/* <td>{value.comments}</td> */}
                        <Tooltip title={value?.comments?.length > 20 ? value?.comments : null}>
                            <td>
                                <a>{value?.comments?.length > 20 ? `${value?.comments.substring(0, 20)}...` : value?.comments}</a>
                            </td>
                        </Tooltip>
                    </tr>
                );
            });
        }
    }

    function bindAcknowledgedUsers() {
        if (ackData?.length == 0) {
            return (
                <tr>
                    <td colSpan={10}>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/vadivelu.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            />

                            <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return ackData?.map((value, index) => {
                return (
                    <tr key={index}>
                        {/* <td>{value.emp_name}</td> */}

                        <td className=" profile-det-popover curser-pointer">
                            <div className="d-flex align-items-center">
                                <a>
                                    <img
                                        src={DOMPurify.sanitize(value.profile_img_url) ? DOMPurify.sanitize(value.profile_img_url) : '/Images/logo-person-user-person-icon.jpg'}
                                        className="table-image"
                                    />
                                </a>
                                <div className="ms-2">
                                    <h4 className="mb-1 font-17 bold-text">{value.emp_name}</h4>
                                    <p className="directory-domain-style mb-0">{value.role ? value.role : '-'}</p>
                                </div>
                            </div>
                        </td>

                        <td>{value.domain}</td>
                        <td>{formatDate(value.modified_at)}</td>
                    </tr>
                );
            });
        }
    }

    function bindUnAcknowledgedUsers() {
        if (unackData?.length == 0) {
            return (
                <tr>
                    <td colSpan={10}>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/vadivelu.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            />

                            <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return unackData?.map((value, index) => {
                return (
                    <tr key={index}>
                        {/* <td>{value.emp_name}</td> */}
                        <td className=" profile-det-popover curser-pointer">
                            <div className="d-flex align-items-center">
                                <a>
                                    <img
                                        src={DOMPurify.sanitize(value.profile_img_url) ? DOMPurify.sanitize(value.profile_img_url) : '/Images/logo-person-user-person-icon.jpg'}
                                        className="table-image"
                                    />
                                </a>
                                <div className="ms-2">
                                    <h4 className="mb-1 font-17 bold-text">{value.emp_name}</h4>
                                    <p className="directory-domain-style mb-0">{value.role ? value.role : '-'}</p>
                                </div>
                            </div>
                        </td>
                        <td>{value.domain}</td>
                    </tr>
                );
            });
        }
    }

    // export to excel
    const ackExportExcel = async () => {
        if (ackData.length) {
            try {
                setIsLoading(true);
                let ExportToExcelArray = ackData?.map((item) => {
                    return item;
                });
                let newexcel = XLSX.utils.book_new();
                let data = XLSX.utils.json_to_sheet(ExportToExcelArray);
                newexcel.SheetNames = ['Acknowledged_Users'];
                const ack_user = XLSX.utils.json_to_sheet(ExportToExcelArray);
                ack_user['A1'].s = {};
                newexcel.Sheets.Acknowledged_Users = ack_user;

                XLSX.writeFile(newexcel, `AcknowledgedUsers_${moment().format('YYYY-MM-DD hh_mm_ss')}.xlsx`);
            } catch (e) {
                console.log('error', e.message);
            }
        }
    };

    const unackExportExcel = async () => {
        if (unackData.length) {
            try {
                setIsLoading(true);
                let ExportToExcelArray = unackData?.map((item) => {
                    return item;
                });
                let newexcel = XLSX.utils.book_new();
                let data = XLSX.utils.json_to_sheet(ExportToExcelArray);
                newexcel.SheetNames = ['UnAcknowledged_Users'];
                const unack_user = XLSX.utils.json_to_sheet(ExportToExcelArray);
                unack_user['A1'].s = {};
                newexcel.Sheets.UnAcknowledged_Users = unack_user;

                XLSX.writeFile(newexcel, `UnAcknowledgedUsers_${moment().format('YYYY-MM-DD hh_mm_ss')}.xlsx`);
            } catch (e) {
                console.log('error', e.message);
            }
        }
    };

    function filterClear() {
        setIsLoading(true);
        const ackObjClear = {
            policyId: policyId,
            domain: '',
            fromDate: '',
            toDate: '',
            search: '',
            order: 'ASC',
            page: 1,
            limit: 10000,
            sort: 'emp_name',
        };
        setPolicyAcknowledged(ackObjClear);

        const unAckObjClear = {
            policyId: policyId,
            domain: '',
            search: '',
            order: 'ASC',
            page: 1,
            limit: 10000,
            sort: 'e.policy_id',
        };
        setPolicyUnAcknowledged(unAckObjClear);
        setClearFilter(!clearFilter);
        setFilterpopup(false);
    }

    function handleClear() {
        setPolicyAcknowledged({ ...policyAcknowledged, search: '' });
        setPolicyUnAcknowledged({ ...policyUnAcknowledged, search: '' });
        setSearchAck('');
    }

    const handleSort = (key) => {
        let sortID = key;
        let sortval = sortID.split('@');
        const sortedData = [...auditData].sort((a, b) => {
            if (sortOrder === 'asc') {
                if (a[key] < b[key]) return -1;
                if (a[key] > b[key]) return 1;
                return 0;
            } else {
                if (a[key] < b[key]) return 1;
                if (a[key] > b[key]) return -1;
                return 0;
            }
        });
        setColumnName(sortval[0]);
        setColumnOrder(sortval[1]);
        setAuditData(sortedData);
        // Toggle sort order
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    return (
        <>
            <div className="container-fluid mt-5">
                <Loader isLoading={isLoading} />
                <div className="row">
                    <div className="col-md-11" style={{ marginTop: '10px' }}>
                        <BreadCrumbs data={breadCrumbsData} />
                    </div>
                    <div className="col-md-12">
                        <div className=" px-4">
                            <div className="d-md-flex d-grid align-items-center justify-content-md-between mt-3">
                                {!policyId ? (
                                    <h2 className="mb-3 mb-md-0 heading-color bold-text font-18">
                                        <a href="policy" className="me-3">
                                            <span>
                                                <img
                                                    src="Images/Policy/arrow-policy.svg"
                                                    alt="a"
                                                    onClick={() => {
                                                        navigateTo('/policy');
                                                    }}
                                                />
                                            </span>
                                        </a>
                                        Create New Policy
                                    </h2>
                                ) : editId ? (
                                    <h2 className="mb-3 mb-md-0 heading-color bold-text font-18">
                                        <a href="policy" className="me-3">
                                            <span>
                                                <img
                                                    src="Images/Policy/arrow-policy.svg"
                                                    alt="a"
                                                    onClick={() => {
                                                        navigateTo('/policy');
                                                    }}
                                                />
                                            </span>
                                        </a>
                                        Edit {editPolicyName}
                                    </h2>
                                ) : (
                                    <h2 className="mb-3 mb-md-0 heading-color bold-text font-18">
                                        <a href="policy" className="me-3">
                                            <span>
                                                <img
                                                    src="Images/Policy/arrow-policy.svg"
                                                    alt="a"
                                                    onClick={() => {
                                                        navigateTo('/policy');
                                                    }}
                                                />
                                            </span>
                                        </a>
                                        View {policyDetails.policyName}
                                    </h2>
                                )}
                                <div>
                                    {/* audit and user analytics */}
                                    {policyId && (
                                        <div className="d-grid gap-2 d-md-block">
                                            <button
                                                type="button"
                                                style={{ marginRight: '10px' }}
                                                className="btn btn-outline-warning font-14 semibold-text  policy-outline box-shadow-none"
                                                data-bs-toggle="modal"
                                                data-bs-target="#auditHistory"
                                                onClick={() => setAuditPopup(true)}
                                            >
                                                View Audit History
                                            </button>
                                            {auditPopup && (
                                                <div class="modal fade" id="auditHistory" tabindex="-1" aria-hidden="true">
                                                    <div class="modal-dialog modal-xl modal-dialog-centered">
                                                        <div class="modal-content">
                                                            <div class="modal-header border-0">
                                                                <h5 class="modal-title font-16 bold-text audit-grey-color">
                                                                    Audit History
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    class="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                ></button>
                                                            </div>
                                                            <div class="modal-body p-0">
                                                                <div class="tab-content">
                                                                    <div class="tab-pane fade show active" id="allPolicy" role="tabpanel">
                                                                        <div class="table-responsive bg-white  mt-2 policy-table policy-table popup-scroll">
                                                                            <table class="table table-borderless ">
                                                                                <thead class="semibold-text font-12 sticky-top">
                                                                                    <tr>
                                                                                        <th>
                                                                                            Time Stamp{' '}
                                                                                            <span class="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="created_at@ASC"
                                                                                                    hidden={sortOrder == 'asc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() => handleSort('created_at')}
                                                                                                />
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="created_at@DESC"
                                                                                                    hidden={sortOrder == 'desc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() => handleSort('created_at')}
                                                                                                />
                                                                                            </span>
                                                                                        </th>
                                                                                        <th>
                                                                                            User
                                                                                            <span class="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="emp_name@ASC"
                                                                                                    hidden={sortOrder == 'asc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() => handleSort('emp_name')}
                                                                                                />
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="emp_name@DESC"
                                                                                                    hidden={sortOrder == 'desc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() => handleSort('emp_name')}
                                                                                                />
                                                                                            </span>
                                                                                        </th>
                                                                                        <th>
                                                                                            Activity
                                                                                            <span class="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="approver_action@ASC"
                                                                                                    hidden={sortOrder == 'asc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() =>
                                                                                                        handleSort('approver_action')
                                                                                                    }
                                                                                                />
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    className="hive-table-sort"
                                                                                                    id="approver_action@DESC"
                                                                                                    hidden={sortOrder == 'desc'}
                                                                                                    // value={getActivePolices.policy_name}
                                                                                                    onClick={() =>
                                                                                                        handleSort('approver_action')
                                                                                                    }
                                                                                                />
                                                                                            </span>
                                                                                        </th>
                                                                                        <th>Comments</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody class="regular-text font-12">
                                                                                    {bindPolicyAudit()}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <button
                                                type="button"
                                                className="btn btn-outline-warning font-14 semibold-text  policy-outline box-shadow-none"
                                                data-bs-toggle="modal"
                                                data-bs-target="#GeneralRegulations"
                                                onClick={() => setAnalyticsPopup(true)}
                                            >
                                                View User Analytics
                                            </button>
                                            {analyticsPopup && (
                                                <div
                                                    className="modal fade"
                                                    id="GeneralRegulations"
                                                    data-bs-backdrop="static"
                                                    tabIndex={-1}
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                                        <div className="modal-content">
                                                            <div className="modal-header border-0">
                                                                <h5 className="modal-title mb-0 heading-color bold-text font-18">
                                                                    {policyDetails.policyName} Analytics{' '}
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    onClick={() => {
                                                                        handleClear();
                                                                        filterClear();
                                                                    }}
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body pt-0 border-0">
                                                                <div className="d-flex align-items-center justify-content-between mt-1">
                                                                    <ul className="nav nav-tabs border-0 ">
                                                                        <li className="nav-item me-4">
                                                                            <button
                                                                                className="nav-link active border-0 policy-tab font-14 semibold-text"
                                                                                data-bs-toggle="tab"
                                                                                data-bs-target="#AcknowledgedUsers"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    handleClear();
                                                                                    setTab(false);
                                                                                    setFilterpopup(false);
                                                                                }}
                                                                                aria-selected="true"
                                                                            >
                                                                                Acknowledged Users <span>({ackData.length})</span>
                                                                            </button>
                                                                        </li>
                                                                        <li className="nav-item me-4">
                                                                            <button
                                                                                className="nav-link border-0 policy-tab font-14 semibold-text"
                                                                                data-bs-toggle="tab"
                                                                                data-bs-target="#UnacknowledgedUsers"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    handleClear();
                                                                                    setTab(true);
                                                                                    setFilterpopup(false);
                                                                                }}
                                                                                aria-selected="false"
                                                                            >
                                                                                Unacknowledged Users <span>({unackData.length})</span>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                    <div>
                                                                        <ul className="nav">
                                                                            <li>
                                                                                {tab == false ? (
                                                                                    <div className="input-group flex-nowrap search-group me-2">
                                                                                        <input
                                                                                            type="search"
                                                                                            className="form-control search-alig-popup"
                                                                                            placeholder="Search"
                                                                                            aria-label="Username"
                                                                                            aria-describedby="addon-wrapping"
                                                                                            value={searchAck}
                                                                                            onChange={(e) => {
                                                                                                setSearchAck(e.target.value);
                                                                                            }}
                                                                                            onKeyDown={(e) => {
                                                                                                if (e.keyCode == 13) {
                                                                                                    setPolicyAcknowledged({
                                                                                                        ...policyAcknowledged,
                                                                                                        search: e.target.value,
                                                                                                    });
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        <button
                                                                                            className="input-group-text btn btn-search-custom-popup align-items-center d-flex"
                                                                                            id="addon-wrapping"
                                                                                        >
                                                                                            <img
                                                                                                src="Images/Policy/todo-find-icon.svg"
                                                                                                alt="search-icon"
                                                                                                className="todo-find-icon"
                                                                                                onClick={(e) => {
                                                                                                    setPolicyAcknowledged({
                                                                                                        ...policyAcknowledged,
                                                                                                        search: searchAck,
                                                                                                    });
                                                                                                }}
                                                                                            />
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="input-group flex-nowrap search-group me-2">
                                                                                        <input
                                                                                            type="search"
                                                                                            className="form-control search-alig-popup"
                                                                                            placeholder="Search"
                                                                                            aria-label="Username"
                                                                                            aria-describedby="addon-wrapping"
                                                                                            value={searchAck}
                                                                                            onChange={(e) => {
                                                                                                setSearchAck(e.target.value);
                                                                                            }}
                                                                                            onKeyDown={(e) => {
                                                                                                if (e.keyCode == 13) {
                                                                                                    setPolicyUnAcknowledged({
                                                                                                        ...policyUnAcknowledged,
                                                                                                        search: e.target.value,
                                                                                                    });
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        <button
                                                                                            className="input-group-text btn btn-search-custom-popup align-items-center d-flex"
                                                                                            id="addon-wrapping"
                                                                                        >
                                                                                            <img
                                                                                                src="Images/Policy/todo-find-icon.svg"
                                                                                                alt="search-icon"
                                                                                                className="todo-find-icon"
                                                                                                onClick={(e) => {
                                                                                                    setPolicyUnAcknowledged({
                                                                                                        ...policyUnAcknowledged,
                                                                                                        search: searchAck,
                                                                                                    });
                                                                                                }}
                                                                                            />
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </li>
                                                                            <li>
                                                                                {/*Filter Section Starts Here*/}
                                                                                {tab == false ? (
                                                                                    <div className="dropdown">
                                                                                        <button
                                                                                            className=" me-2 medium-text cust-filt-popupbtn"
                                                                                            type="button"
                                                                                            data-bs-toggle="dropdown"
                                                                                            aria-expanded="false"
                                                                                            onClick={() => {
                                                                                                filterCheck();
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                src="Images/Policy/filter-icon.svg"
                                                                                                alt="Filter-icon"
                                                                                                className="me-2"
                                                                                            />
                                                                                            Filter
                                                                                        </button>
                                                                                        {filterPopup == true && (
                                                                                            <div
                                                                                                className="dropdown-menu px-3 advanced-filter-panel"
                                                                                                style={{ display: 'block' }}
                                                                                            >
                                                                                                <div className="col-md-12">
                                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                                        <h5 className="font-18 semibold-text text-black mb-0">
                                                                                                            Advanced Filter
                                                                                                        </h5>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn-close"
                                                                                                            onClick={() => {
                                                                                                                filterCheck();
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-6 col-sm-12">
                                                                                                        <div className="mb-3">
                                                                                                            <label
                                                                                                                className="form-label text-black font-14 bold-text"
                                                                                                                htmlFor="Domain"
                                                                                                            >
                                                                                                                Domain
                                                                                                            </label>

                                                                                                            <select
                                                                                                                className="form-control hive-form-control"
                                                                                                                value={
                                                                                                                    policyAcknowledged.domain
                                                                                                                }
                                                                                                                onChange={(e) => {
                                                                                                                    setPolicyAcknowledged({
                                                                                                                        ...policyAcknowledged,
                                                                                                                        domain: e.target
                                                                                                                            .value,
                                                                                                                    });
                                                                                                                }}
                                                                                                            >
                                                                                                                <option value="">
                                                                                                                    Select
                                                                                                                </option>
                                                                                                                {groupsDropdown?.map(
                                                                                                                    (value, index) => {
                                                                                                                        return (
                                                                                                                            <option
                                                                                                                                key={index}
                                                                                                                                value={
                                                                                                                                    value
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {value}
                                                                                                                            </option>
                                                                                                                        );
                                                                                                                    }
                                                                                                                )}
                                                                                                            </select>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-12 pb-2 border-0 ">
                                                                                                        <span className="font-14 semibold-text filter-title">
                                                                                                            Start Date
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div className="row mb-3">
                                                                                                        <div className="col-md-6 mb-3">
                                                                                                            {/* <div className="mb-3"> */}
                                                                                                            <label
                                                                                                                className="form-label hive-form-label"
                                                                                                                htmlFor="fromrange"
                                                                                                            >
                                                                                                                From
                                                                                                            </label>
                                                                                                            <input
                                                                                                                type="date"
                                                                                                                className="form-control hive-form-control"
                                                                                                                id="startFrom"
                                                                                                                name="startFrom"
                                                                                                                value={
                                                                                                                    policyAcknowledged.fromDate
                                                                                                                }
                                                                                                                onChange={(e) => {
                                                                                                                    setPolicyAcknowledged({
                                                                                                                        ...policyAcknowledged,
                                                                                                                        fromDate:
                                                                                                                            e.target.value,
                                                                                                                    });
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="col-md-6 mb-3">
                                                                                                            {/* <div className="mb-3"> */}
                                                                                                            <label
                                                                                                                className="form-label hive-form-label"
                                                                                                                htmlFor="torange"
                                                                                                            >
                                                                                                                To
                                                                                                            </label>
                                                                                                            <input
                                                                                                                type="date"
                                                                                                                className="form-control hive-form-control"
                                                                                                                id="startTo"
                                                                                                                value={
                                                                                                                    policyAcknowledged.toDate
                                                                                                                }
                                                                                                                onChange={(e) => {
                                                                                                                    setPolicyAcknowledged({
                                                                                                                        ...policyAcknowledged,
                                                                                                                        toDate: e.target
                                                                                                                            .value,
                                                                                                                    });
                                                                                                                }}
                                                                                                            />
                                                                                                            {/* </div> */}
                                                                                                        </div>
                                                                                                        <div className="text-end mt-4 mb-2">
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                                                                                onClick={() => {
                                                                                                                    filterClear();
                                                                                                                }}
                                                                                                            >
                                                                                                                Clear
                                                                                                            </button>
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                                                                onClick={() => {
                                                                                                                    getAcknowledgedUsers();
                                                                                                                    setFilterpopup(false);
                                                                                                                }}
                                                                                                            >
                                                                                                                Apply
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="dropdown">
                                                                                        <button
                                                                                            className="advanced-filter-button me-2 medium-text"
                                                                                            type="button"
                                                                                            id="dropdownMenuButton1"
                                                                                            onClick={() => {
                                                                                                filterCheck();
                                                                                            }}
                                                                                            data-bs-toggle="dropdown"
                                                                                            aria-expanded="false"
                                                                                        >
                                                                                            <img
                                                                                                src="Images/Policy/filter-icon.svg"
                                                                                                alt="Filter-icon"
                                                                                                className="me-2"
                                                                                            />
                                                                                            Filter
                                                                                        </button>
                                                                                        {filterPopup == true && (
                                                                                            <div
                                                                                                className="dropdown-menu px-3 advanced-filter-panel"
                                                                                                style={{ display: 'block' }}
                                                                                            >
                                                                                                <div className="col-md-12">
                                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                                        <h5 className="font-18 semibold-text text-black mb-0">
                                                                                                            Advanced Filter
                                                                                                        </h5>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn-close"
                                                                                                            onClick={() => {
                                                                                                                filterCheck();
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="row mt-3">
                                                                                                        <div className="col-md-6 col-sm-12">
                                                                                                            <div className="mb-3">
                                                                                                                <label
                                                                                                                    className="form-label text-black font-14 bold-text"
                                                                                                                    htmlFor="Domain"
                                                                                                                >
                                                                                                                    Domain
                                                                                                                </label>
                                                                                                                <select
                                                                                                                    className="form-select cust-input-sty font-14 font-regular"
                                                                                                                    onChange={(e) => {
                                                                                                                        setPolicyUnAcknowledged(
                                                                                                                            {
                                                                                                                                ...policyUnAcknowledged,
                                                                                                                                domain: e
                                                                                                                                    .target
                                                                                                                                    .value,
                                                                                                                            }
                                                                                                                        );
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <option value="">
                                                                                                                        Select
                                                                                                                    </option>
                                                                                                                    {groupsDropdown?.map(
                                                                                                                        (value, index) => {
                                                                                                                            return (
                                                                                                                                <option
                                                                                                                                    key={
                                                                                                                                        index
                                                                                                                                    }
                                                                                                                                    value={
                                                                                                                                        value
                                                                                                                                    }
                                                                                                                                >
                                                                                                                                    {value}
                                                                                                                                </option>
                                                                                                                            );
                                                                                                                        }
                                                                                                                    )}
                                                                                                                </select>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="text-end mt-4 mb-2">
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                                                                            onClick={() => {
                                                                                                                filterClear();
                                                                                                            }}
                                                                                                        >
                                                                                                            Clear
                                                                                                        </button>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                                                            onClick={() => {
                                                                                                                getUnAcknowledgedUsers();
                                                                                                                setFilterpopup(false);
                                                                                                            }}
                                                                                                        >
                                                                                                            Apply
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </li>
                                                                            {/*Filter Section Ends Here*/}
                                                                            {tab == false ? (
                                                                                <li>
                                                                                    <button
                                                                                        className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                                        type="button"
                                                                                        id="dropdownMenuButton1"
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                        onClick={(e) => ackExportExcel(e)}
                                                                                    >
                                                                                        Export to Excel
                                                                                    </button>
                                                                                </li>
                                                                            ) : (
                                                                                <li>
                                                                                    <button
                                                                                        className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                                        type="button"
                                                                                        id="dropdownMenuButton1"
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                        onClick={(e) => unackExportExcel(e)}
                                                                                    >
                                                                                        Export to Excel
                                                                                    </button>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="tab-content">
                                                                    <div
                                                                        className="tab-pane fade show active"
                                                                        id="AcknowledgedUsers"
                                                                        role="tabpanel"
                                                                    >
                                                                        <div className="table-responsive bg-white  mt-4 policy-table popup-scroll">
                                                                            <table className="table table-borderless">
                                                                                <thead className="semibold-text font-12">
                                                                                    <tr>
                                                                                        <th>
                                                                                            Employee Name{' '}
                                                                                            <span className="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    alt="sort-down"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'ASC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'emp_name',
                                                                                                            order: 'ASC',
                                                                                                        });
                                                                                                    }}
                                                                                                />

                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    alt="sort-up"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'DESC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'emp_name',
                                                                                                            order: 'DESC',
                                                                                                        });
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </th>

                                                                                        <th>
                                                                                            Domain
                                                                                            <span className="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    alt="sort-down"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'ASC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'domain',
                                                                                                            order: 'ASC',
                                                                                                        });
                                                                                                        // setIsLoading(false);
                                                                                                    }}
                                                                                                />

                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    alt="sort-up"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'DESC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'domain',
                                                                                                            order: 'DESC',
                                                                                                        });
                                                                                                        // setIsLoading(false);
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </th>

                                                                                        <th>
                                                                                            Acknowledged On
                                                                                            <span className="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    alt="sort-down"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'ASC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'modified_at',
                                                                                                            order: 'ASC',
                                                                                                        });
                                                                                                        // setIsLoading(false);
                                                                                                    }}
                                                                                                />

                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    alt="sort-up"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyAcknowledged.order == 'DESC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyAcknowledged({
                                                                                                            ...policyAcknowledged,
                                                                                                            sort: 'modified_at',
                                                                                                            order: 'DESC',
                                                                                                        });
                                                                                                        // setIsLoading(false);
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="regular-text font-12">
                                                                                    {bindAcknowledgedUsers()}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <p className="font-12 regular-text mt-2">
                                                                            Showing <span className="bold-text">{ackData?.length}</span> of{' '}
                                                                            {ackCount}
                                                                        </p>
                                                                    </div>
                                                                    <div className="tab-pane fade" id="UnacknowledgedUsers" role="tabpanel">
                                                                        <div className="table-responsive bg-white  mt-4 policy-table popup-scroll">
                                                                            <table className="table table-borderless ">
                                                                                <thead className="semibold-text font-12">
                                                                                    <tr>
                                                                                        <th>
                                                                                            Employee Name{' '}
                                                                                            <span className="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    alt="sort-down"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyUnAcknowledged.order == 'ASC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyUnAcknowledged({
                                                                                                            ...policyUnAcknowledged,
                                                                                                            sort: 'emp_name',
                                                                                                            order: 'ASC',
                                                                                                        });
                                                                                                    }}
                                                                                                />

                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    alt="sort-up"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyUnAcknowledged.order == 'DESC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyUnAcknowledged({
                                                                                                            ...policyUnAcknowledged,
                                                                                                            sort: 'emp_name',
                                                                                                            order: 'DESC',
                                                                                                        });
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </th>

                                                                                        <th>
                                                                                            Domain
                                                                                            <span className="ms-2">
                                                                                                <img
                                                                                                    src="Images/Policy/sort-up.svg"
                                                                                                    alt="sort-down"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyUnAcknowledged.order == 'ASC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyUnAcknowledged({
                                                                                                            ...policyUnAcknowledged,
                                                                                                            sort: 'domain',
                                                                                                            order: 'ASC',
                                                                                                        });
                                                                                                    }}
                                                                                                />

                                                                                                <img
                                                                                                    src="Images/Policy/sort-down.svg"
                                                                                                    alt="sort-up"
                                                                                                    className="cursor-pointer"
                                                                                                    hidden={
                                                                                                        policyUnAcknowledged.order == 'DESC'
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        setPolicyUnAcknowledged({
                                                                                                            ...policyUnAcknowledged,
                                                                                                            sort: 'domain',
                                                                                                            order: 'DESC',
                                                                                                        });
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="regular-text font-12">
                                                                                    {bindUnAcknowledgedUsers()}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <p className="font-12 regular-text mt-2">
                                                                            Showing <span className="bold-text">{unackData?.length}</span>{' '}
                                                                            of {unackCount}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="ps-3 ms-4">
                                <p className="bold-text font-16 mt-3">Policy Details</p>
                                <div className="row mt-4  gx-5">
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="policyName">
                                            Policy Name <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control cust-input-sty font-14 semibold-text"
                                            disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                            id="policyName"
                                            placeholder="Enter policy name"
                                            name="policyName"
                                            value={policyDetails.policyName}
                                            onChange={handleChange}
                                        />
                                        <span className="policy-validation">{policyValidation.policyName}</span>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="startDate">
                                            Start Date <span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className=" cust-date form-control  cust-input-sty font-14 semibold-text"
                                            disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                            id="startDate"
                                            name="startDate"
                                            value={policyDetails?.startDate}
                                            onChange={handleChange}
                                        />
                                        <span className="policy-validation">{policyValidation.startDate}</span>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="expiryDate">
                                            Expiry Date <span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className=" cust-date form-control  cust-input-sty font-14 semibold-text "
                                            disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                            id="expiryDate"
                                            name="expiryDate"
                                            value={policyDetails?.expiryDate}
                                            onChange={handleChange}
                                        />
                                        <span className="policy-validation">{policyValidation.expiryDate}</span>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="startFrom">
                                            Policy Control Owner <span className="required">*</span>
                                        </label>
                                        <div className="dropdown">
                                            {policyId ? (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    name="controlOwner"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Controller Name"
                                                    // value={controlOwnerDropdown
                                                    //         .filter(option => policyDetails.controlOwner?.includes(option.emp_id))
                                                    //         .map(option => ({ label: option.emp_name, value: option.emp_id }))
                                                    // }
                                                    value={
                                                        controlOwner
                                                            ? controlOwner
                                                            : controlOwnerDropdown
                                                                .filter((option) =>
                                                                    policyDetails.controlOwner.some(
                                                                        (owner) => owner.value === option.emp_id
                                                                    )
                                                                )
                                                                .map((option) => ({ label: option.emp_name, value: option.emp_id }))
                                                    }
                                                    options={controlOwnerDropdown?.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    onChange={handlecontrolowner}
                                                    isMulti
                                                    isClearable
                                                />
                                            ) : (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    name="controlOwner"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Controller Name"
                                                    value={controlOwner}
                                                    options={controlOwnerDropdown?.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    onChange={handlecontrolowner}
                                                    isMulti
                                                    isClearable
                                                />
                                            )}
                                            {/* <Select
                                                className="dropdown"
                                                // isDisabled={viewId !== null || encryptStorage.getItem('secAudits') || (encryptStorage.getItem('groupid')==1)}
                                                name="controlOwner"
                                                maxMenuHeight={150}
                                                placeholder="Select control owners"
                                                // value={controlOwnerDropdown
                                                //         .filter(option => policyDetails.controlOwner?.includes(option.emp_id))
                                                //         .map(option => ({ label: option.emp_name, value: option.emp_id }))
                                                // }
                                                value={controlOwnerDropdown
                                                        .filter(option => policyDetails.controlOwner.some(owner => owner.value === option.emp_id))
                                                        .map(option => ({ label: option.emp_name, value: option.emp_id }))                                                  
                                                }
                                                options={controlOwnerDropdown?.map(option => ({ label: option.emp_name, value: option.emp_id }))}
                                                onChange={handlecontrolowner}
                                                isMulti
                                                isClearable
                                            /> */}
                                            <span className="policy-validation">{policyValidation.controlOwner}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="startFrom">
                                            Signature Required <span className="required">*</span>
                                        </label>
                                        <div className="d-flex gap-5 regular-text font-14 mt-2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input policy-check"
                                                    disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    type="radio"
                                                    name="signatureRequired"
                                                    id="signReqYes"
                                                    defaultChecked={true}
                                                    value={policyDetails.signatureRequired}
                                                    checked={policyDetails.signatureRequired == true}
                                                    onChange={(e) => {
                                                        setPolicyDetails({ ...policyDetails, [e.target.name]: true });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="signReqYes">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input policy-check"
                                                    disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    type="radio"
                                                    name="signatureRequired"
                                                    id="signReqNo"
                                                    defaultChecked={false}
                                                    value={policyDetails.signatureRequired}
                                                    checked={policyDetails.signatureRequired == false}
                                                    onChange={(e) => {
                                                        setPolicyDetails({ ...policyDetails, [e.target.name]: false });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="signReqNo">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text" htmlFor="startFrom">
                                            Category <span className="required">*</span>
                                        </label>
                                        <div className="d-flex gap-5 regular-text font-14 mt-2">
                                            {policyId ? (
                                                <div className="form-check">
                                                    {/* <input 
                                                    className="form-check-input policy-check"
                                                    disabled={viewId !== null || (!encryptStorage.getItem('grc'))}
                                                    value='group'
                                                    checked={policyDetails.category === 'group' || policyDetails.category === 'both'}
                                                    type="checkbox"
                                                    id="categoryGroup"
                                                    onChange={handleCategory}
                                                /> */}
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        type="checkbox"
                                                        name="group"
                                                        checked={policyDetails.category === 'group' || policyDetails.category === 'both'}
                                                        onChange={handleCategory}
                                                    />
                                                    <label className="form-check-label" htmlFor="categoryGroup">
                                                        Groups
                                                    </label>
                                                </div>
                                            ) : (
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="group"
                                                        type="checkbox"
                                                        id="categoryGroup"
                                                        onChange={handleCategory}
                                                    />
                                                    <label className="form-check-label" htmlFor="categoryGroup">
                                                        Groups
                                                    </label>
                                                </div>
                                            )}
                                            {policyId ? (
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="individual"
                                                        checked={
                                                            policyDetails.category === 'individual' || policyDetails.category === 'both'
                                                        }
                                                        type="checkbox"
                                                        id="categoryIndividual"
                                                        onChange={handleCategory}
                                                    />
                                                    <label className="form-check-label" htmlFor="categoryIndividual">
                                                        Individual
                                                    </label>
                                                </div>
                                            ) : (
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="individual"
                                                        type="checkbox"
                                                        id="categoryIndividual"
                                                        onChange={handleCategory}
                                                    />
                                                    <label className="form-check-label" htmlFor="categoryIndividual">
                                                        Individual
                                                    </label>
                                                </div>
                                            )}
                                            <span className="policy-validation">{policyValidation.category}</span>
                                        </div>
                                    </div>
                                    {policyDetails.category === 'group' || policyDetails.category === 'both' ? (
                                        <div className="col-md-4 mb-4">
                                            <label className="form-label text-black font-14 bold-text">
                                                Select Groups <span className="required">*</span>
                                            </label>
                                            <div className="dropdown">
                                                {policyId ? (
                                                    <Select
                                                        className="dropdown"
                                                        isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="groupNames"
                                                        maxMenuHeight={150}
                                                        placeholder="Select groups"
                                                        value={
                                                            groups
                                                                ? groups
                                                                : groupsDropdown
                                                                    .filter((option) =>
                                                                        policyDetails.groupNames.some((group) => group.label == option)
                                                                    )
                                                                    .map((option) => ({ label: option, value: option }))
                                                        }
                                                        options={groupsDropdown?.map((option) => ({ label: option, value: option }))}
                                                        onChange={handlegroups}
                                                        isMulti
                                                        isClearable
                                                    />
                                                ) : (
                                                    <Select
                                                        className="dropdown"
                                                        isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="groupNames"
                                                        maxMenuHeight={150}
                                                        placeholder="Select groups"
                                                        value={groups}
                                                        options={groupsDropdown?.map((option) => ({ label: option, value: option }))}
                                                        onChange={handlegroups}
                                                        isMulti
                                                        isClearable
                                                    />
                                                )}
                                                <span className="policy-validation">{policyValidation.groupNames}</span>
                                            </div>
                                        </div>
                                    ) : null}
                                    {policyDetails.category === 'individual' || policyDetails.category === 'both' ? (
                                        <div className="col-md-4 mb-4">
                                            <label className="form-label text-black font-14 bold-text">
                                                Select Individual <span className="required">*</span>
                                            </label>
                                            <div className="dropdown">
                                                {policyId ? (
                                                    <Select
                                                        className="dropdown"
                                                        hidden={policyDetails.category == 'group'}
                                                        isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="individualId"
                                                        maxMenuHeight={150}
                                                        placeholder="Select individual"
                                                        value={
                                                            individual
                                                                ? individual
                                                                : individualDropdown
                                                                    .filter((option) =>
                                                                        policyDetails.individualId.some(
                                                                            (group) => group.label == option.emp_id
                                                                        )
                                                                    )
                                                                    .map((option) => ({ label: option.emp_name, value: option.emp_id }))
                                                        }
                                                        options={individualDropdown?.map((option) => ({
                                                            label: option.emp_name,
                                                            value: option.emp_id,
                                                        }))}
                                                        onChange={handleindividual}
                                                        isMulti
                                                        isClearable
                                                    />
                                                ) : (
                                                    <Select
                                                        className="dropdown"
                                                        hidden={policyDetails.category == 'group'}
                                                        isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                        name="individualId"
                                                        maxMenuHeight={150}
                                                        placeholder="Select individual"
                                                        value={individual}
                                                        options={individualDropdown?.map((option) => ({
                                                            label: option.emp_name,
                                                            value: option.emp_id,
                                                        }))}
                                                        onChange={handleindividual}
                                                        isMulti
                                                        isClearable
                                                    />
                                                )}
                                                <span className="policy-validation">{policyValidation.individualId}</span>
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="col-md-12 mb-4">
                                        <label className="form-label hive-form-label">
                                            Policy Description <span className="required">*</span>
                                        </label>
                                        <textarea
                                            className="form-select hive-form-control"
                                            placeholder="Enter policy description"
                                            rows="3"
                                            style={{ resize: 'none' }}
                                            defaultValue={''}
                                            name="policyDescription"
                                            disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                            value={policyDetails.policyDescription}
                                            onChange={handleChange}
                                        />
                                        <span className="policy-validation">{policyValidation.policyDescription}</span>
                                    </div>
                                    {/* Approval details starts here  */}
                                    <p className="bold-text font-16 mt-3">Approver Details</p>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label hive-form-label">
                                            Approver Level 1 <span className="required">*</span>
                                        </label>
                                        <div className="dropdown">
                                            {policyId ? (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    name="approverLevel1"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Approver"
                                                    value={level1SelectedValues}
                                                    options={bindLevel1Approver?.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    onChange={(e) => {
                                                        if (policyDetails?.approverDetails?.length <= 5 || e?.length == 0 || e.length < 5)
                                                            handleApproverlevel(e, 1);
                                                    }}
                                                    isMulti
                                                    isClearable
                                                />
                                            ) : (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    name="approverLevel1"
                                                    maxMenuHeight={150}
                                                    value={level1SelectedValues}
                                                    placeholder="Select Approver"
                                                    options={bindLevel1Approver?.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    onChange={(e) => {
                                                        if (policyDetails?.approverDetails?.length <= 5 || e?.length == 0 || e.length < 5)
                                                            handleApproverlevel(e, 1);
                                                    }}
                                                    isMulti
                                                    isClearable
                                                />
                                            )}
                                            {policyValidation.approverDetails1 && (
                                                <span className="policy-validation">{policyValidation.approverDetails1}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text">
                                            Approver Level 2 <span className="required">*</span>
                                        </label>
                                        <div className="dropdown">
                                            <Select
                                                className="dropdown"
                                                isDisabled
                                                name="approverLevel2"
                                                maxMenuHeight={150}
                                                defaultValue={{ label: 'Sec Audits', value: 'Sec Audits' }}
                                                placeholder="Sec Audits"
                                                onChange={(e) => handleApproverlevel(e, 2)}
                                            />
                                            {/* <span className="policy-validation">{policyValidation.approverDetails}</span> */}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <label className="form-label text-black font-14 bold-text">
                                            Approver Level 3 <span className="required">*</span>
                                        </label>
                                        <div className="dropdown">
                                            {policyId ? (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    // value={bindLevel3Approver
                                                    //     .filter(option => policyDetails.approverDetails && policyDetails.approverDetails.includes(option.emp_id))
                                                    //     .map(option => ({ label: option.emp_name, value: option.emp_id }))
                                                    // }
                                                    value={level3SelectedValues}
                                                    name="approverLevel3"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Approver"
                                                    options={bindLevel3Approver.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    onChange={(e) => {
                                                        if (e.length < 3) handleApproverlevel(e, 3);
                                                    }}
                                                    isMulti
                                                    isClearable
                                                />
                                            ) : (
                                                <Select
                                                    className="dropdown"
                                                    isDisabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                    // value={bindLevel3Approver
                                                    //     .filter(option => policyDetails.approverDetails && policyDetails.approverDetails.includes(option.emp_id))
                                                    //     .map(option => ({ label: option.emp_name, value: option.emp_id }))
                                                    // }
                                                    name="approverLevel3"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Approver"
                                                    options={bindLevel3Approver.map((option) => ({
                                                        label: option.emp_name,
                                                        value: option.emp_id,
                                                    }))}
                                                    value={level3SelectedValues}
                                                    onChange={(e) => {
                                                        if (e.length < 3) handleApproverlevel(e, 3);
                                                    }}
                                                    isMulti
                                                    isClearable
                                                />
                                            )}
                                            <span className="policy-validation">{policyValidation.approverDetails3}</span>
                                        </div>
                                    </div>
                                    {/* Approval details ends here  */}
                                    {encryptStorage.getItem('grc') ? (
                                        <p className="bold-text font-16 mt-3">
                                            Upload Policy <span className="required">*</span>
                                        </p>
                                    ) : (
                                        <p className="bold-text font-16 mt-3">Link to Policy</p>
                                    )}
                                    <div className="col-md-4 mb-3">
                                        <span className="d-block">
                                            {!selectedFile && !policyDetails.policyURL ? (
                                                <label
                                                    className="cust-file-policy font-14 bold-text d-inline-block cursor-pointer"
                                                    htmlFor="addAttch"
                                                >
                                                    <img src="Images/Policy/Up-Arrow-upload.svg" alt="Up-Arrow-upload" className="me-2" />
                                                    Upload
                                                </label>
                                            ) : (
                                                <></>
                                            )}
                                            <input
                                                type="file"
                                                disabled={viewId !== null || !encryptStorage.getItem('grc')}
                                                className="d-none opacity-file"
                                                id="addAttch"
                                                onChange={handleFileChange}
                                                ref={attachment}
                                            />
                                            {policyDetails.policyURL && (
                                                <span>
                                                    <a
                                                        href="#"
                                                        style={{ cursor: "pointer" }} 
                                                        onClick={async () => {                                 
                                                            window.open(await getS3(policyDetails.policyURL), "_blank");
                                                       }}
                                                    >
                                                       {policyDetails.policyURL.split('/').pop()}
                                                    </a>
                                                </span>
                                            )}
                                        </span>

                                        {selectedFile && encryptStorage.getItem('grc') && !viewId ? (
                                            <label className="text-danger">
                                                <a href={DOMPurify.sanitize(policyDoc)} target="_blank">
                                                    {policyDoc.split('/').pop()}
                                                </a>
                                                <span>
                                                    {' '}
                                                    <img
                                                        src="/Images/Policy/policy-cancel.svg"
                                                        className="cursor-pointer"
                                                        alt="Cancel Icon"
                                                        onClick={removeDocument}
                                                    />
                                                </span>
                                            </label>
                                        ) : null}

                                        {!(selectedFile || (policyDetails.policyURL && viewId)) ? (
                                            <p className="font-12 regular-text mt-2 upload-label-colr">(Allowed file type: PDF)</p>
                                        ) : null}

                                        <span className="policy-validation">{policyValidation.policyURL}</span>
                                    </div>
                                    {!encryptStorage.getItem('grc') ? (
                                        <div>
                                            <p className="bold-text font-16 mt-0">Approver’s Action </p>
                                            <div className=" gap-5 regular-text font-14 mt-2">
                                                <div className="form-check mb-3">
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={
                                                            viewId ||
                                                            !(encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1)
                                                        }
                                                        type="radio"
                                                        name="approveAction"
                                                        value="approved"
                                                        checked={policyApproval.approverAction == 'approved'}
                                                        onChange={(e) => {
                                                            setPolicyApproval({ ...policyApproval, approverAction: 'approved' });
                                                        }}
                                                        id="approvePolicy"
                                                        defaultChecked
                                                    />
                                                    <label className="form-check-label" htmlFor="approvePolicy">
                                                        Approve
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input policy-check"
                                                        disabled={
                                                            viewId ||
                                                            !(encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1)
                                                        }
                                                        type="radio"
                                                        name="approveAction"
                                                        checked={policyApproval.approverAction == 'rejected'}
                                                        value="rejected"
                                                        onChange={(e) => {
                                                            setPolicyApproval({ ...policyApproval, approverAction: 'rejected' });
                                                        }}
                                                        id="rejectPolicy"
                                                    />
                                                    <label className="form-check-label" htmlFor="rejectPolicy">
                                                        Reject
                                                    </label>
                                                </div>
                                            </div>
                                            {policyApproval.approverAction == 'rejected' ? (
                                                <div className="col-md-12 mb-4 mt-3">
                                                    <label className="form-label hive-form-label">
                                                        Comments<span className="required">*</span>
                                                    </label>
                                                    <textarea
                                                        className="form-select hive-form-control"
                                                        rows="3"
                                                        style={{ resize: 'none' }}
                                                        defaultValue={''}
                                                        disabled={
                                                            viewId ||
                                                            !(encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1)
                                                        }
                                                        name="comments"
                                                        value={policyApproval.comments}
                                                        onChange={(e) => {
                                                            setPolicyApproval({ ...policyApproval, comments: e.target.value });
                                                        }}
                                                    />
                                                    <span className="policy-validation">{policyValidation.comments}</span>
                                                </div>
                                            ) : (
                                                <div className="col-md-12 mb-4 mt-3">
                                                    <label className="form-label hive-form-label">Comments </label>
                                                    <textarea
                                                        className="form-select hive-form-control"
                                                        rows={'3'}
                                                        style={{ resize: 'none' }}
                                                        defaultValue={''}
                                                        disabled={
                                                            viewId ||
                                                            !(encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1)
                                                        }
                                                        name="comments"
                                                        value={policyApproval.comments}
                                                        onChange={(e) => {
                                                            setPolicyApproval({ ...policyApproval, comments: e.target.value });
                                                        }}
                                                    />
                                                    <span className="policy-validation">{policyValidation.comments}</span>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    {/* clear and update */}
                                    {!viewId && (
                                        <div className="text-end  mb-5">
                                            <button
                                                type="button"
                                                className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                onClick={() => {
                                                    // if (encryptStorage.getItem("grc")) {
                                                    //     setPolicyDetails(policyDetailsObj)
                                                    //     setLevel1SelectedValues([]);
                                                    //     setLevel3SelectedValues([]);
                                                    //     setControlOwner([]);
                                                    //     setIndividual([]);
                                                    //     setGroups([]);
                                                    //     setSelectedFile("");
                                                    // }
                                                    // else {
                                                    navigateTo('/policy');
                                                    // }
                                                }}
                                            >
                                                {/* {encryptStorage.getItem("grc")?"Clear":"Cancel"} */}
                                                {!editId ? 'Clear' : 'Cancel'}
                                            </button>
                                            {encryptStorage.getItem('grc') ? (
                                                <button
                                                    type="button"
                                                    className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                    onClick={(e) => {
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    {policyId ? 'Update' : 'Submit for Approval'}
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                    onClick={() => {
                                                        try {
                                                            setHasMore(!hasMore);
                                                            handleApproval();
                                                        } catch (error) {
                                                            console.log(error.message);
                                                        }
                                                    }}
                                                >
                                                    Submit
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
